import tippy from 'tippy.js';

const productComponent = document.querySelector('#product-altar-service-component');

function loadTippy() {
    tippy('a.info', {
        content(reference) {
            const id = reference.getAttribute('data-info');
            const template = document.getElementById(id);
            return template.innerHTML;
        },
        allowHTML: true,
    });
}

export function tooltips() {
    loadTippy();

    if (productComponent) {
        productComponent.addEventListener('reloadTippy', function () {
            loadTippy();
        })
    }
}
